export const DISPLAY_FIELD_OVERRIDES = {
  'Bridges (point)': 'BRIDGE_ID'
};
